import styled from "styled-components";

export const ButtonStyled = styled.button`
  max-width: 270px;
  max-height: 30px;
  font-size: 13px;
  font-weight: 500;
  align-items: center;
  padding: 8px;
  border: none;
  border-radius: 4px;


  box-shadow: inset 0px 0px 10px 2px rgba(100, 100, 100, 0.5);
  cursor: pointer;

  &:hover {
    background-color: rgba(200, 200, 200, 0.2);  
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 13px;
      grid-column: 1;
  }
`;
